export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormUser = {
        idusuario: '',
        nombreusuario: '',
        userNameMessage: '',
        nombre: '',
        apellido: '',
        email: '',
        userpassword: '',
        pswMsg: ''
    }

    const defaultFormPermissionAssignment = {
        idusuario: '',
        permissionsAssigned: []
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormUser,
        defaultFormPermissionAssignment
    })
}